/**
 * Routes of the household feature (household sheet, registration door, my
 * follow-ups), mounted inside the protected shell by `src/App.tsx`.
 */
import './household.css';

import { HouseholdSheetPage } from './pages/HouseholdSheetPage';
import { MyFollowupsPage } from './pages/MyFollowupsPage';
import { RegistrationDoorPage } from './pages/RegistrationDoorPage';

import type { RouteObject } from 'react-router-dom';

export const householdRoutes: RouteObject[] = [
  { path: '/sessions/:id/door', element: <HouseholdSheetPage /> },
  { path: '/sessions/:id/door/registration', element: <RegistrationDoorPage /> },
  { path: '/cases', element: <MyFollowupsPage /> },
];
